import { Grid, Tooltip} from "@mui/material";

export function getWorkerStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'Title',
            value:'',
            error:false,
            errorMessage:'You must enter Title',
            required:true,
            fieldtype:'string'
        },
        skillid:{
            name:'skillid',
            label:'Skill  Id',
            value:'',
            error:false,
            errorMessage:'You must enter Skill  Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        skillname:{
            name:'skillname',
            label:'Skill  Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        experiencelevelid:{
            name:'experiencelevelid',
            label:'Experience Level Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        experiencelevelname:{
            name:'experiencelevelname',
            label:'Experience Level Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        typeid:{
            name:'typeid',
            label:'Type Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'Title', width:100 },
        { field: 'skillid', headerName: 'Skill  Id', width:150 },
        { field: 'skillname', headerName: 'Skill  Name', width:150 },
        { field: 'typeid', headerName: 'Type Id', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['skillid']:{
          ...formValues['skillid'],
          value:data.skillid,
        },['skillname']:{
          ...formValues['skillname'],
          value:data.skillname,
        },['experiencelevelid']:{
          ...formValues['experiencelevelid'],
          value:data.experiencelevelid,
        },['experiencelevelname']:{
          ...formValues['experiencelevelname'],
          value:data.experiencelevelname,
        },['typeid']:{
          ...formValues['typeid'],
          value:data.typeid,
        },
      })
}